import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

import { BaseChartProps } from '../types/chartProps';
import { applyLineChartOptions } from '../utils/lineChartUtils';
import { applyRedrawForBaseChart } from '../utils/baseChartUtils';
import { mergeWithDefaults } from '../utils/chartDefaults';

export const LineChart = React.memo(
  React.forwardRef<HighchartsReact.RefObject, BaseChartProps>((props, ref) => {
    const redraw = { skip: false };
    const options: Highcharts.Options = applyLineChartOptions(
      mergeWithDefaults({
        chart: {
          type: 'line',
          events: {
            redraw: applyRedrawForBaseChart(redraw)
          }
        }
      }),
      { ...props, kind: 'line' }
    );

    return <HighchartsReact highcharts={Highcharts} options={options} ref={ref} />;
  })
);
